import { ArrowUpRight } from "lucide-react";

export default function MetricCard({ label, value, hint, tone, Icon, testid }) {
  return (
    <div className="metric" data-testid={testid}>
      <div className={`metric-icon ${tone}`}>
        <Icon size={18} />
      </div>
      <div className="metric-label">{label}</div>
      <div className="metric-value">{value}</div>
      {hint ? (
        <div className={`metric-hint ${tone}`}>
          <ArrowUpRight size={13} /> {hint}
        </div>
      ) : null}
    </div>
  );
}
